import { render, staticRenderFns } from "./MLiveHome.vue?vue&type=template&id=ffebe684&"
import script from "./MLiveHome.vue?vue&type=script&lang=js&"
export * from "./MLiveHome.vue?vue&type=script&lang=js&"
import style0 from "./MLiveHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports